import api from "api";

export const fetchGlossary = async () => await api.get("/glossary");
